window.AppState = window.AppState || {};

(function () {
    this.AllCountryCodes = ["us", "uk", "au", "de", "fr", "jp", "cn", "kr"];
    this.AllInactiveCountryCodes = ["cn"]; 
    this.AllActiveCountryCodes = ["us", "uk", "au", "de", "fr", "jp", "kr"];
    

    this.GetCurrentLanguageCode = function () {
        return "US";
    };
    
    this.GetCurrentLanguageUrlPrefix = function () {
        return "";
    };

    this.GetCurrentLanguageName = function () {
        return "en";
    };

    /*
        key <string>: the name of the query string parameter to get,
        options: {
            defaultValue <any>: a default value when the actual value is null or undefined.
            parse <bool>: whether or not to JSON.parse the value before returning.
        }
    */
    this.getQueryParameter = function (key, { defaultValue, parse = false } = {}) {
        var queryParams = window.location.search.substring(1);
        var keyValuePairs = queryParams.split('&').map(kv => kv.split('='));
        var kvPair = keyValuePairs.filter(kv => kv[0] === key)?.[0] || [];
        var [_key, value] = kvPair;

        if (parse && typeof value === "string") {
            try {
                value = JSON.parse(value);
            } catch (e) {
                console.warn(e);
            }
        }

        return (value == null) && (typeof defaultValue !== "undefined")
            ? defaultValue 
            : value;
    };

  /**
   *
   * @param {string} key: the cookie name to get,
   * @param {object?} options
   * @param {any} options.defaultValue: a default value when the actual value is null or undefined.
   * @param {boolean} options.parse: whether or not to JSON.parse the value before returning.
   */
  this.getCookie = function (key, { defaultValue, parse = false } = {}) {
    var val = parse ? Cookies.getJSON(key) : Cookies.get(key);
    if ((val == null) && (typeof defaultValue !== "undefined")) {
      return defaultValue;
    }

    return (typeof val === "string") ? val.trim() : val;
  };

  /*
        key <string>: the cookie name to set.
        value <string or object>: value for the cookie. Objects are written as stringified JSON.
        options <object>: These are the options to set the cookie with.
            {
                expires <number, date object>: when a number is provided (can be fractional), # of days from now. If Date obj, exact expiration date. DEFAULT: session only,
                domain <string>: Domain to set the cookie for. DEFAULT: current subdomain.
                path <string>: Path the cookie is valid for.  DEFAULT: Entire site, "/".
            }
    */
  this.setCookie = function (key, value, options) {
    if ((value == null)) {
      return AppState.removeCookie(key, options);
    }
    if ((options != null) && (typeof options !== "object")) {
      console.log(
        "In AppState.setCookie. Parameter 'options' should be an object."
      );
    }

    if (options != null && (typeof options === "object")) {
      return Cookies.set(key, value, options);
    } else {
      return Cookies.set(key, value);
    }
  };

  /*
        key <string>: the cookie name to delete.
        options <object>: These must match the values used to set the cookie except the "expires" property
    */
  this.removeCookie = function (key, options) {
    if (options) {
      return Cookies.remove(key, options);
    } else {
      return Cookies.remove(key);
    }
  };

  /* ---------------------- Set in other places ---------------------
        AppState.PageOfferId             ==> From InjectPageDataWidget
        AppState.ResolveUrlByLanguageMap ==> From InjectPageDataWidget
        AppState.WidgetData              ==> from widgetData.js
    ------------------------------------------------------------------*/
}.call(window.AppState));